import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'Upload',
  data: function data() {
    return {
      photo: null,
      openPhotoUpload: false
    };
  },
  computed: {
    isApp: get('config/isApp'),
    themeStyle: function themeStyle() {
      return {
        color: this.$store.getters['theme/theme'].primaryColor
      };
    }
  },
  methods: {
    /**
     * Handle a photo being uploaded
     */
    uploadPhoto: function uploadPhoto() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.photo) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return _this.$store.dispatch('responses/upload', {
                  payload: {
                    image: _this.photo
                  },
                  errorBehaviour: {
                    messageFormatter: function messageFormatter(error) {
                      var _error$detail, _error$detail$upload, _error$detail$upload$;

                      // Use the first returned listed error (they'll have to fix that before moving onto
                      // the other errors anyway), and if none such returned, fall back to the general error message.
                      return (error === null || error === void 0 ? void 0 : (_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : (_error$detail$upload = _error$detail.upload) === null || _error$detail$upload === void 0 ? void 0 : (_error$detail$upload$ = _error$detail$upload.errors) === null || _error$detail$upload$ === void 0 ? void 0 : _error$detail$upload$[0]) || error.message;
                    }
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    removeImage: function removeImage() {
      this.photo = null;
      this.openPhotoUpload = false;
    },
    complete: function complete() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var hasImage;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hasImage = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;

                if (!hasImage) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this2.uploadPhoto();

              case 4:
                if (!_this2.$store.getters['errors/error']) {
                  _this2.$router.push('/checkout');
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};